/* eslint-disable react/display-name */
import React, { memo, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';

import { reduxConnect } from '../../../common';
import { AqiHealthAdviceTopTriggerModalHeader } from './aqiHealthAdviceTopTriggerModalHeader';
import { AqiHealthAdviceTopTriggerModalBody } from './aqiHealthAdviceTopTriggerModalBody';

import { closeAqiPollutantHealthAdvicePopup } from '../../../common/actions/aqiTopTriggerHealthAdviceDetailsModalActions';
import { AirQualityRecommendations, IStoreState } from '../../common/interfaces/types';
import { HealthAdviceTypes, PollutantType } from './types';
import { useAirQualityProvider } from '../../../hooks/useAirQualityProvider';

interface AqiTopTriggerHealthAdvicePopupProps {
    isTopTriggerHealthAdviceDetailPopupOpen: boolean;
    selectedAqiHealthAdvice: keyof typeof HealthAdviceTypes;
    selectedAqiPollutant: keyof typeof PollutantType;
    recommendations: AirQualityRecommendations;
    closeAqiPollutantHealthAdvicePopup: () => void;
    authId: string;
    secret: string;
    aqiBaseUrl: string;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { airQuality, aqiTopTriggerHealthAdviceDetailModal, appState } = storeState ?? {};
    const { authId, secret, aqiBaseUrl } = appState?.appState || {};
    const { currentAirQuality } = airQuality ?? {};
    const { isTopTriggerHealthAdviceDetailPopupOpen, selectedAqiHealthAdvice, selectedAqiPollutant } = aqiTopTriggerHealthAdviceDetailModal ?? {};
    const { recommendations } = currentAirQuality ?? {};

    return {
        isTopTriggerHealthAdviceDetailPopupOpen,
        selectedAqiHealthAdvice,
        selectedAqiPollutant,
        recommendations,
        authId,
        secret,
        aqiBaseUrl
    };
};

const mapDispatchToProps = {
    closeAqiPollutantHealthAdvicePopup
};

export const AqiTopTriggerHealthAdvicePopup = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({
    isTopTriggerHealthAdviceDetailPopupOpen = false,
    selectedAqiHealthAdvice,
    selectedAqiPollutant,
    recommendations,
    closeAqiPollutantHealthAdvicePopup,
    authId,
    secret,
    aqiBaseUrl }: AqiTopTriggerHealthAdvicePopupProps) => {
    
    const [pollutantDetailList, setPollutantDetailList] = useState<string[]>([]);
    const [healthAdviceDetail, setHealthAdviceDetail] = useState<string>('');

    const { pollutantTypes } = useAirQualityProvider(aqiBaseUrl, authId, secret);
    
    useEffect(() => {
        if (isTopTriggerHealthAdviceDetailPopupOpen) {
            if (selectedAqiPollutant) {
                const selectedPollutantInfo = pollutantTypes?.find((pollutantInfo) => pollutantInfo?.apiField === selectedAqiPollutant);
                if (selectedPollutantInfo) {
                    setPollutantDetailList(selectedPollutantInfo.details);
                }
            } else if (selectedAqiHealthAdvice && recommendations) {
                const aqiAdviceDetail = recommendations?.[selectedAqiHealthAdvice as keyof typeof recommendations] ?? '';
                setHealthAdviceDetail(aqiAdviceDetail);
            }
        }
        return () => {
            setPollutantDetailList([]);
            setHealthAdviceDetail('');
        };
    }, [selectedAqiPollutant, selectedAqiHealthAdvice, recommendations, isTopTriggerHealthAdviceDetailPopupOpen]);

    return (
        <Modal 
            open={isTopTriggerHealthAdviceDetailPopupOpen} 
            onClose={closeAqiPollutantHealthAdvicePopup} 
            styles={modalStyles} 
            center={true}>
            <AqiHealthAdviceTopTriggerModalHeader />
            <AqiHealthAdviceTopTriggerModalBody
                healthAdviceDetails={healthAdviceDetail} 
                pollutantDetailsList={pollutantDetailList} />
        </Modal>
    );
}));

const modalStyles = {
    closeIcon: {
        fill: '#555555',
        width: 24,
        height: 24
    }
};
